import React, { useContext, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
// import theme from "../../assets/images/signup.png"
import theme from "../../assets/images/login_img_new.png"
import logo from "../../assets/images/logo.png"
import { useFormik } from "formik"
import { AuthService, UserLoginData } from "services/AuthService"
import { toast } from "react-toastify"
toast.configure()
import "react-toastify/dist/ReactToastify.css"
import { RequestState } from "enum/RequestState"
import { loginSchema } from "schemas/loginSchema"
import jwt_decode from "jwt-decode"
import Copyright from "components/Common/copyright"
import { RouteContext } from "context/RouteProvider"
import {  signInWithCustomToken } from "firebase/auth";
import { auth } from "admin/DriverTracking/DriverTracking"
import { AuthData, useAuth } from "context/AuthProvider"



const Signin: React.FC = () => {
  const navigate = useNavigate()
  const [isProtected, setIsProtected] = useContext(RouteContext)
  const [, , , , refreshUser] = useAuth() as AuthData
  const [loginRequestState, setLoginRequestState] = useState<RequestState>(RequestState.INITIAL)
  const [showPassword, setShowPassword] = useState(false)

  const onSubmit = async (values: UserLoginData, actions: any) => {
    try {
      setLoginRequestState(RequestState.LOADING)
      const email = values.emailOrUserName
      const res = await AuthService.userLogin(values)
      if (res.success) {


        // 🔐 Admin Firebase login
        const firebaseToken = (res as any).firebaseToken;
        if (firebaseToken) {
          await signInWithCustomToken(auth, firebaseToken);
        }


        setLoginRequestState(RequestState.SUCCESS)
        const data: any = await jwt_decode(res.data)
        await refreshUser()
        navigate(`/${data?.user_role}/place-orders`, { replace: true })
      } else if (res.errorCode === 1) {
        setLoginRequestState(RequestState.FAILED)
        setIsProtected(true)
        navigate("/email-verification", { state: { email: email } })
      } else {
        setLoginRequestState(RequestState.FAILED)

        toast.error(res.error, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        })
      }
    } catch (error) {
      setLoginRequestState(RequestState.FAILED)
    }
    actions.resetForm()
  }

  const { values, errors, touched, isSubmitting, handleBlur, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      emailOrUserName: "",
      password: "",
      termsAndConditions: false,
    },
    validationSchema: loginSchema,
    onSubmit, // Fix the attribute name here
  })

  const handleCheckboxChange = () => {
    setFieldValue("termsAndConditions", !values.termsAndConditions)
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  document.title = "Login | Zulu Courier Dashboard "

  return (
    <div className="container">
      <form onSubmit={handleSubmit} autoComplete="off">
        <section className="my-4">
          <div className="position-relative">
            <div className="row g-5 w-100 justify-content-center sign-form">
              <div className="col-lg-7 col-md-12 col-sm-12 d-flex align-items-center justify-content-center">
                <img src={theme} alt="" className="w-100 px-5 py-5 position-relative" />
              </div>

              <div className="col-lg-5 col-md-12 col-sm-12 d-flex align-items-center justify-content-center">
                <div className="px-4 py-5 w-100">
                  <div className="sign-logo mb-3">
                    <a href="/home">
                      {/* <a href="https://zulucourier.com/home"> */}
                      <img src={logo} alt="" />
                    </a>
                  </div>
                  <h3 className="title my-4 text-black">Customer Login</h3>
                  <p className="mb-4">
                    Do not have an account? <a href="/signup">Sign up now</a>
                  </p>
                  <div className="form-groupco mt-2">
                    <label className="place-order-title">Username / Email</label>
                    <input
                      value={values.emailOrUserName}
                      onChange={handleChange}
                      name="emailOrUserName"
                      id="emailOrUserName"
                      type="text"
                      placeholder=""
                      onBlur={handleBlur}
                      className={errors.emailOrUserName && touched.emailOrUserName ? "input-error form-control" : "form-control"}
                    />

                    {errors.emailOrUserName && touched.emailOrUserName && <label className="error place-order-title">{errors.emailOrUserName}</label>}
                  </div>
                  <div className="form-group mt-2">
                    <label className="place-order-title">Password</label>
                    <div className="password-input-container">
                      <input
                        value={values.password}
                        onChange={handleChange}
                        name="password"
                        id="password"
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        onBlur={handleBlur}
                        className={errors.password && touched.password ? "input-error form-control" : "form-control"}
                      />
                      {values.password && (
                        <button
                          type="button"
                          className="password-toggle-btn"
                          onClick={togglePasswordVisibility}
                        >
                          {showPassword ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-eye-slash" viewBox="0 0 16 16">
                              <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                              <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                              <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                            </svg>
                          )}
                        </button>
                      )}
                    </div>
                    {errors.password && touched.password && <label className="error place-order-title">{errors.password}</label>}
                  </div>

                  <div className="form-group mb-4">
                    <Link to="/forget-password">Forgot your password?</Link>
                  </div>

                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-12">
                        <input
                          checked={values.termsAndConditions}
                          className="me-2"
                          type="checkbox"
                          onChange={handleCheckboxChange}
                          onBlur={handleBlur}
                        />

                        <label className="place-order-title ms-2">Remember Me</label>
                        {errors.termsAndConditions && touched.termsAndConditions && (
                          <p className="error place-order-title">{errors.termsAndConditions}</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button disabled={isSubmitting} className="btn btn-md bg-orange text-white w-100 mt-4 button-bg">
                      Log In
                    </button>
                  </div>

                  <div className="w-100 text-center mt-5">
                    <Copyright />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  )
}

export default Signin
